import { createSlice } from "@reduxjs/toolkit";
import { ReducerRegistry } from "@neumetric/blueprint-lib/store";

const initialState = {
  modelList: [],
  reportFormats: [],
  modelDetails: null,
  modelDetailsLoading: false,
  modelDetailsError: null,
  deactivateModelSuccess: false,
  reactivateModelSuccess: false,
  allocateModelSuccess: false,
  reportBlueprints: null,
  currentAuditReport: null,
};
const auditorSlice = createSlice({
  name: "auditor",
  initialState: initialState,
  reducers: {
    fetchModelList: () => {},
    setModelList: (state, action) => {
      state.modelList = action.payload;
    },
    fetchReportFormats: () => {},
    setReportFormats: (state, action) => {
      state.reportFormats = action.payload;
    },
    createModel: () => {},
    updateModel: () => {},
    fetchModelDetails: (state, action) => {
      state.modelDetailsLoading = true;
      state.modelDetailsError = null;
      // also clear old details when switching
      state.modelDetails = null;
    },
    setModelDetails: (state, action) => {
      state.modelDetailsLoading = false;
      state.modelDetails = action.payload;
    },
    setModelDetailsError: (state, action) => {
      state.modelDetailsLoading = false;
      state.modelDetailsError =
        action.payload || "Error while loading details.";
    },
    deactivateModel: () => {},
    deactivateModelSuccess: (state) => {
      state.deactivateModelSuccess = true;
    },
    resetDeactivateModelSuccess: (state) => {
      state.deactivateModelSuccess = false;
    },
    reactivateModel: () => {},
    reactivateModelSuccess: (state) => {
      state.reactivateModelSuccess = true;
    },
    resetReactivateModelSuccess: (state) => {
      state.reactivateModelSuccess = false;
    },
    allocateModelToOrgs: () => {},
    allocateModelToOrgsSuccess: (state) => {
      state.allocateModelSuccess = true;
    },
    resetAllocateModelToOrgsSuccess: (state) => {
      state.allocateModelSuccess = false;
    },
    fetchAuditReportBlueprints: () => {},
    fetchAuditReportBlueprint: () => {},
    createAuditReportBlueprint: () => {},
    updateAuditReportBlueprint: () => {},
    setAuditReportsBlueprints: (state, action) => {
      state.reportBlueprints = action.payload;
    },
    setCurrentAuditReport: (state, action) => {
      state.currentAuditReport = action.payload;
    },
  },
});
export const auditorActions = auditorSlice.actions;
ReducerRegistry.register("auditor", auditorSlice.reducer);
